import { RootState } from 'stores/index'
import { getPartyDistribution } from 'lib/selectors'
import { connect } from 'react-redux'
import { PartyChart as component } from 'components/partyChart/partyChart'

const mapStateToProps = (state: RootState) => ({
  distribution:
    navigator.userAgent !== 'ReactSnap' ? getPartyDistribution(state) : {}
})

export const PartyChart = connect(mapStateToProps)(component)
